import React, { useEffect, useState } from 'react';
import { Table, Spin, message, Tooltip } from 'antd';
import {
    VerticalAlignTopOutlined,
    VerticalAlignBottomOutlined,
    RetweetOutlined,
} from '@ant-design/icons';
import axios from '../../../config/axiosInstance';

const LeadsTab = ({ participantId, host, programmePoints }) => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchLeads = async () => {
        try {
            setLoading(true);
            const tokenRes = await axios.get(`/regasus/token?host=${host}`);
            const token = tokenRes.data.access_token;

            if (!token) return message.error('Token not received');

            const res = await axios.post('/regasus/get-leads-of-participant', {
                token,
                host,
                participantId
            });

            setLeads(res.data?.leads || []);
        } catch (err) {
            console.error(err);
            message.error('Failed to load leads');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeads();
    }, []);

    const getProgrammePointName = (id) => {
        const match = programmePoints?.find(p => p.id === id);
        return match?.name?.[0]?.value || id;
    };

    const columns = [
        {
            title: 'Direction',
            dataIndex: 'direction',
            key: 'direction',
            render: (value) => {
                if (value === 'I') {
                    return <VerticalAlignTopOutlined style={{ color: 'green', fontSize: 18 }} />;
                } else if (value === 'O') {
                    return <VerticalAlignBottomOutlined style={{ color: 'red', fontSize: 18 }} />;
                } else if (value === 'p') {
                    return <RetweetOutlined style={{ color: '#00CED1', fontSize: 18 }} />;
                } else {
                    return '—';
                }
            },
        },
        {
            title: 'Collected At',
            dataIndex: 'collectTime',
            key: 'collectTime',
            render: (value) =>
                value ? new Date(value).toLocaleString() : '—',
        },
        {
            title: 'Programme Point',
            dataIndex: 'programmePointID',
            key: 'programmePointID',
            render: (value) => getProgrammePointName(value),
        },
        {
            title: 'Source',
            dataIndex: 'source',
            key: 'source',
            render: (value) => {
                if (value === 't') {
                    return <Tooltip title="Scanned via tag"><span style={{ color: '#1890ff' }}>Tag</span></Tooltip>;
                } else if (value === 'a') {
                    return <Tooltip title="Automatically generated"><span style={{ color: '#faad14' }}>Auto</span></Tooltip>;
                } else if (value === 'm') {
                    return <Tooltip title="Manually created"><span style={{ color: '#722ed1' }}>Manual</span></Tooltip>;
                } else {
                    return value || '—';
                }
            },
        },
        {
            title: 'Comment',
            dataIndex: 'comment',
            key: 'comment',
            render: (value) => value || '—',
        },
    ];

    return loading ? (
        <Spin />
    ) : (
        <Table
            size="small"
            scroll={{ x: 'max-content' }}
            dataSource={leads.map((l, i) => ({ key: l.id || i, ...l }))}
            columns={columns}
            pagination={{ pageSize: 10 }}
        />
    );
};

export default LeadsTab;